import { render, staticRenderFns } from "./ContactGroupSelect.vue?vue&type=template&id=50a0ecd8"
import script from "./ContactGroupSelect.vue?vue&type=script&lang=ts"
export * from "./ContactGroupSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports